@if (!!href()) {
    <a
        target="_blank"
        rel="noopener noreferrer"
        [attr.href]="href()"
        [class]="class()"
        [ngClass]="btnClass()"
        [class.underline]="hasUnderline()"
        [class.btn--destructive]="destructive()"
        [attr.data-id]="id()"
    >
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </a>
} @else if (!!routeTo()) {
    <a
        [routerLink]="routeTo()"
        [queryParams]="queryParams()"
        [class]="class()"
        [ngClass]="btnClass()"
        [class.underline]="hasUnderline()"
        [class.btn--destructive]="destructive()"
        [attr.data-id]="id()"
    >
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </a>
} @else {
    <button
        [attr.type]="submit() ? 'submit' : 'button'"
        [disabled]="disabled() || loading()"
        [class]="class()"
        [ngClass]="btnClass()"
        [class.underline]="hasUnderline()"
        [class.btn--destructive]="destructive()"
        [class.btn--loading]="loading()"
        [attr.data-id]="id()"
        (click)="handleClick($event)"
    >
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
}

<ng-template #buttonTemplate>
    @if (loading()) {
        <stby-loader-dots />
    }

    @if (icon() && iconPosition() === 'left') {
        <stby-icon class="btn__icon" [icon]="icon()" [size]="iconSize$()" [rotate]="rotate()" [alt]="icon()" />
    }

    @if (label()) {
        <span class="btn__label">{{ label() | translate: labelParams() }}</span>
    }

    @if (icon() && iconPosition() === 'right') {
        <stby-icon class="btn__icon" [icon]="icon()" [size]="iconSize$()" [rotate]="rotate()" [alt]="icon()" />
    }
</ng-template>
